import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rating"]

  connect() {
    console.log('Hello from ratings_controller.js')
  }
}
